(function () {
  'use strict';
  const page = document.querySelector('[data-help-page]');
  if (!page) return;
  function reveal(hash, focus) {
    let id;
    try { id = decodeURIComponent(hash.replace(/^#/, '')); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !page.contains(target)) return;
    if (target.matches('details')) target.open = true;
    for (let parent = target.parentElement; parent && parent !== page; parent = parent.parentElement) {
      if (parent.matches('details')) parent.open = true;
    }
    if (focus) {
      const destination = target.matches('details') ? target.querySelector('summary') : target;
      if (!destination.hasAttribute('tabindex')) destination.setAttribute('tabindex', '-1');
      destination.focus({preventScroll:true});
    }
    return target;
  }
  page.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = reveal(link.hash, true);
    if (target) {
      event.preventDefault();
      history.pushState(null, '', link.hash);
      target.scrollIntoView();
    }
  });
  window.addEventListener('hashchange', () => reveal(location.hash, false));
  if (location.hash) {
    reveal(location.hash, false);
    requestAnimationFrame(() => {
      try { document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView(); } catch {}
    });
  }
})();
